export const percentageFormatter = Intl.NumberFormat("en-US", {
  style: "percent"
})

export const upperFirst = (value: string): string =>
  value.length === 0 ? "" : value[0].toUpperCase() + value.slice(1)

const splitIntoWords = (value: string = ""): string[] =>
  value
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .split(/[^a-zA-Z0-9]+/)
    .filter(Boolean)

export const pascalCase = (value: string = ""): string =>
  splitIntoWords(value)
    .map(w => upperFirst(w.toLowerCase()))
    .join("")

export const kabobCase = (value: string = ""): string =>
  splitIntoWords(value).join("-").toLowerCase()

export const formatDataAutomationId = (value: string): string =>
  kabobCase(value)
